export * from './sinister-comment.component';
